import './ProcessesList.css';

import React from 'react';
import Moment from 'react-moment';
import { Button, Dimmer, Header, Icon, Loader, Modal, Pagination, Segment, Table } from 'semantic-ui-react';

import Configuration from './Configuration';
import CoverageCompare from "./CoverageCompare";
import { appConfig } from '../config.js';


const ProcessesList = ({ processes, processesCount, profile, selectedCollection, activeProcess, 
                         onDisplayClick, onPageChange, onRemoveProcess, onRemoveProcesses, onRunProcess, runningProcess, sites }) => {

    const processesPerPage = 5;

    const handlePaginationChange = (e, data) => {
        onPageChange(selectedCollection.pk, data.activePage);
      }

    const getRemoveAllButton = () => {
        if (processes && processes.length===0) {
            return (
                <div></div>
            )
        }
        return (
            <Button icon
                data-tooltip="Remove all processes for this collection"
                data-inverted=""
                onClick={onRemoveProcesses}
            >
                <Icon name='delete' />
            </Button>
        )
    }

    const getStatusIcon = (proc) => {
        if (runningProcess && proc.uuid === runningProcess.uuid){
            proc = runningProcess;
        }
        if (proc.status === 0) {
            return (
                <Segment>
                    <Dimmer active>
                        <Loader size='mini' >
                            {`${proc.progress}%`}
                        </Loader>
                    </Dimmer>
                    .....
                </Segment>
            )
        }
        var status_images = {
            1: 'check icon',
            2: 'warning circle icon'
        };
        return <i aria-hidden="true" className={status_images[proc.status]}></i>;
    }

    const getStatusPopIcon = (proc) => {
        if (runningProcess && proc.uuid === runningProcess.uuid){
            proc = runningProcess;
        }
        if (proc.populationcounterprocess){
            if (proc.populationcounterprocess.status === 0) {
                return (
                    <Segment>
                        <Dimmer active>
                            <Loader size='mini' >
                                {`${proc.populationcounterprocess.progress}%`}
                            </Loader>
                        </Dimmer>
                        .....
                    </Segment>
                )
            }
            if (proc.populationcounterprocess.status === 1){
                return `${proc.population ? proc.population.toLocaleString() : 'N/A'} people`;
            }
        } else {
            return 'N/A';
        }
        
    }

    const getMapButton = (proc) => {
        if (proc.status === 0) {
            return (
                <button className="ui icon button disabled mini" >
                    <i aria-hidden="true" className="map icon"></i>
                </button>
            )
        }
        return (
            <button className="ui icon button mini" 
                data-tooltip="Display result for this process in the map"
                data-inverted=""
                onClick={onDisplayClick.bind(this, proc)} >
                <i aria-hidden="true" className="map icon"></i>
            </button>
        )
    }

    const getDownloadButton = (proc) => {
        var url_kmz = `${appConfig.static_files.URL}kml/${proc.uuid}/${proc.uuid}.kmz`;
        if (proc.status === 0) {
            return (
                <button className="ui icon button disabled mini" >
                    <i aria-hidden="true" className="download icon"></i>
                </button>
            )
        }
        return (
            <a href={url_kmz}>
                <button className="ui icon button mini" 
                    data-tooltip="Download kmz output for this process"
                    data-inverted=""
                >
                    <i aria-hidden="true" className="download icon"></i>
                </button>
            </a>
        )
    }

    const getDownloadCsvButton = (proc) => {
        if (proc.status === 0) {
            return (
                <button className="ui icon button small disabled"
                    data-tooltip="Download the CSV for this process"
                    data-inverted=""
                >
                    <i aria-hidden="true" className="file icon small"></i>
                </button>
            )
        }
        return (
            <a href={`${appConfig.api.URL}/processruns/${proc.pk}/csv`}>
                <button className="ui icon button small"
                    data-tooltip="Download the CSV for this process"
                    data-inverted=""
                >
                    <i aria-hidden="true" className="file icon small"></i>
                </button>
            </a>
        )
    }

    const getCoverageCompareButton = (proc) => {
        if (proc.status === 0) {
            return (
                <Button
                    className="disabled"
                    icon
                    size='tiny'
                    data-tooltip={`Coverage compare: (version ${proc.collection_version.number}, has ${proc.collection_version.sites.length} sites)` }
                    data-inverted=""
                    // Needed for refreshing of sites
                    onClick={onDisplayClick.bind(this, proc)} >
                    <Icon name='closed captioning outline' size='large' />
                </Button>
            )
        }
        return (
            <Modal
                className="modal"
                trigger={<Button icon
                    size='tiny'
                    data-tooltip={`Coverage compare: (version ${proc.collection_version.number}, has ${proc.collection_version.sites.length} sites)` }
                    data-inverted=""
                    // Needed for refreshing of sites
                    onClick={onDisplayClick.bind(this, proc)} >
                    <Icon name='closed captioning outline' size='large' />
                </Button>
                }
                closeIcon={{ style: { top: '1.0535rem', right: '1rem' }, color: 'black', name: 'close' }}>
                <Modal.Content>
                    <Header icon='closed captioning outline' content='Coverage compare' />
                    <CoverageCompare
                        proc={proc}
                        profile={profile}
                        sites={sites}
                    />
                </Modal.Content>
            </Modal>
        )

    }

    if (!processes) {
        return (
             <div></div>
        )
    }

    return (

        <div>

            <div>
                <Button icon
                    className="ui button"
                    data-tooltip="Run a process for this sites collection"
                    data-inverted=""
                    onClick={onRunProcess}
                >
                    <Icon name='play' />
                </Button>
                {getRemoveAllButton()}
            </div>

            <Table celled inverted selectable size='small'>
                <Table.Body>

                    {processes.map(proc =>
                        <Table.Row key={proc.uuid} active={activeProcess && proc.uuid === activeProcess.uuid} >
                            <Table.Cell>
                                <Moment fromNow>{proc.updated}</Moment>
                            </Table.Cell>
                            <Table.Cell>
                                {getStatusIcon(proc)}
                            </Table.Cell>
                            <Table.Cell>
                                {getStatusPopIcon(proc)}
                            </Table.Cell>
                            <Table.Cell>
                                <Modal 
                                    className="modal process-info"
                                    trigger={<Button icon
                                        size='tiny'
                                        data-tooltip={`Configuration used for this process (version ${proc.collection_version.number}, has ${proc.collection_version.sites.length} sites)` }
                                        data-inverted=""
                                    >
                                        <Icon name='info' size='small' />
                                    </Button>
                                    }
                                    closeIcon={{ style: { top: '1.0535rem', right: '1rem' }, color: 'black', name: 'close' }}>
                                    <Modal.Content>
                                        <Header icon='settings' content='Configuration Used' />
                                        <Configuration 
                                            configuration={proc.configuration} 
                                            profile={profile}
                                        />
                                    </Modal.Content>
                                </Modal>
                            </Table.Cell>
                            <Table.Cell>
                                {getMapButton(proc)}
                            </Table.Cell>
                            <Table.Cell>
                                {getDownloadButton(proc)}
                            </Table.Cell>
                            <Table.Cell>
                                {getDownloadCsvButton(proc)}
                            </Table.Cell>
                            <Table.Cell>
                                {getCoverageCompareButton(proc)}
                            </Table.Cell>
                            <Table.Cell>
                                <button className="ui icon button small"
                                    data-tooltip="Remove this process"
                                    data-inverted=""
                                >
                                    <i aria-hidden="true" className="remove icon small" onClick={onRemoveProcess.bind(this, proc.url)}></i>
                                </button>
                            </Table.Cell>
                        </Table.Row>)}

                </Table.Body>
            </Table>

            {processesCount > processesPerPage &&
                <Pagination
                    size='mini'
                    defaultActivePage={1}
                    totalPages={Math.ceil(processesCount / processesPerPage)}
                    onPageChange={handlePaginationChange}
                />
            }

        <div>
            You have  {processesCount} processes so far.
        </div>

        </div>
    );
};

export default ProcessesList;
